import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

const groups = [
  ["news", "News"],
  ["events", "Events"],
  ["notices", "Notices"],
  ["departments", "Departments"],
  ["downloads", "Downloads"],
  ["staff", "Staff"],
  ["campus", "Campus"],
  ["gallery", "Gallery"],
  ["journalIssues", "Journal Issues"],
  ["journalArticles", "Journal Articles"],
  ["alumni", "Alumni"],
  ["partnerships", "Partnerships"],
  ["projects", "Projects"],
];

function resultLink(group, item) {
  const key = item.slug || item.id;
  if (group === "news") return `/news/${key}`;
  if (group === "events") return "/events";
  if (group === "notices") return item.slug ? `/notice-board/${item.slug}` : "/notice-board";
  if (group === "departments") return `/departments/${key}`;
  if (group === "downloads") return "/downloads";
  if (group === "staff") return `/staff/${key}`;
  if (group === "campus") return "/campus-map";
  if (group === "gallery") return "/media-gallery";
  if (group === "journalIssues") return `/journals/${key}`;
  if (group === "journalArticles") return `/journals/article/${key}`;
  if (group === "alumni") return `/alumni/${key}`;
  if (group === "partnerships") return "/partnerships";
  if (group === "projects") return `/projects/${key}`;
  return "/search";
}

export default function SiteSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api(`/api/search?q=${encodeURIComponent(q)}`);
      setResults(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16">
      <section className="mx-auto max-w-6xl">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Find Anything</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Site Search</h1>
        <p className="mt-3 max-w-2xl text-slate-600">Search news, events, notices, departments, downloads, staff, campus map, gallery media, journals, alumni, partnerships and projects.</p>
        <form onSubmit={submit} className="mt-8 flex flex-col gap-3 md:flex-row">
          <input className="flex-1 rounded-2xl border border-slate-300 p-4" placeholder="Search departments, journals, news, notices, downloads, staff..." value={q} onChange={(e) => setQ(e.target.value)} required />
          <button className="rounded-2xl bg-emerald-700 px-6 py-4 font-bold text-white">{loading ? "Searching..." : "Search"}</button>
        </form>
        {error && <div className="mt-6 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
        {results && <div className="mt-8 space-y-8">
          {groups.map(([key, label]) => (
            <section key={key} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
              <h2 className="text-xl font-bold text-slate-900">{label}</h2>
              <div className="mt-4 grid gap-3 md:grid-cols-2">
                {(results[key] || []).map((item) => (
                  <Link to={resultLink(key, item)} key={`${key}-${item.id}`} className="rounded-2xl border border-slate-200 p-4 transition hover:border-emerald-300 hover:bg-emerald-50/40">
                    <h3 className="font-bold text-slate-900">{item.title}</h3>
                    <p className="mt-1 line-clamp-2 text-sm text-slate-600">{item.summary}</p>
                  </Link>
                ))}
                {(!results[key] || results[key].length === 0) && <p className="text-sm text-slate-500">No result found.</p>}
              </div>
            </section>
          ))}
        </div>}
      </section>
    </main>
  );
}
